import { render, staticRenderFns } from "./actividad-indicadores-ars.vue?vue&type=template&id=28cd8ee4&"
import script from "./actividad-indicadores-ars.component.ts?vue&type=script&lang=ts&"
export * from "./actividad-indicadores-ars.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports